import styled from "styled-components";
import { Link } from "react-router-dom";

export const HostelContainer = styled.div`
  padding: 20px;
  background: #f7fafc;
  min-height: 100vh;
`;

export const PageHeader = styled.div`
  margin-bottom: 24px;
  
  h1 {
    font-size: 1.75rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0 0 8px 0;
  }
  
  p {
    color: #718096;
    margin: 0;
  }
`;

export const CurrentBookingCard = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 24px;
  color: white;
  margin-bottom: 24px;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
`;

export const BookingHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  
  h3 {
    font-size: 1.1rem;
    font-weight: 700;
    margin: 0;
  }
  
  .status {
    background: rgba(255, 255, 255, 0.2);
    padding: 6px 14px;
    border-radius: 100px;
    font-size: 0.75rem;
    font-weight: 700;
  }
`;

export const BookingDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  
  .detail {
      font-size: 0.7rem;
      text-transform: uppercase;
      color: #ffffff;
      opacity: 1;
      display: block;
      margin-bottom: 4px;
    }
    
    span {
      font-size: 0.95rem;
      font-weight: 600;
    }
  }
`;

export const HostelsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
`;

export const HostelCard = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }
`;

export const HostelImage = styled.div`
  height: 120px;
  background: ${props => props.gender === "Male"
    ? "linear-gradient(135deg, #4a90e2, #357abd)"
    : props.gender === "Female"
      ? "linear-gradient(135deg, #f093fb, #f5576c)"
      : "linear-gradient(135deg, #11998e, #38ef7d)"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  
  i {
    font-size: 2.5rem;
    opacity: 0.5;
  }
`;

export const HostelInfo = styled.div`
  padding: 20px;
  
  h3 {
    font-size: 1.1rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0 0 8px 0;
  }
`;

export const HostelMeta = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  
  span {
    font-size: 0.75rem;
    color: #718096;
    display: flex;
    align-items: center;
    gap: 4px;
    
    i {
      color: #a0aec0;
    }
  }
`;

export const HostelPrice = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .price {
    font-size: 1.25rem;
    font-weight: 800;
    color: #48bb78;
  }
  
  .per {
    font-size: 0.7rem;
    color: #a0aec0;
  }
`;

export const SelectButton = styled.button`
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }
  
  &:disabled {
    background: #cbd5e0;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
`;

export const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #edf2f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0;
  }
  
  button {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #a0aec0;
    cursor: pointer;
    
    &:hover {
      color: #718096;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
`;

export const RoomCard = styled.div`
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  
  h4 {
    font-size: 0.95rem;
    font-weight: 600;
    color: #2d3748;
    margin: 0 0 12px 0;
  }
`;

export const BedspaceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 8px;
`;

export const BedspaceButton = styled.button`
  padding: 10px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: ${props => props.available ? "pointer" : "not-allowed"};
  transition: all 0.2s ease;
  
  background: ${props => props.selected
    ? "#667eea"
    : props.available
      ? "#eef2ff"
      : "#fef2f2"};
  
  color: ${props => props.selected
    ? "white"
    : props.available
      ? "#667eea"
      : "#f56565"};
  
  border: 2px solid ${props => props.selected
    ? "#667eea"
    : props.available
      ? "#c3dafe"
      : "#fecaca"};
  
  &:hover {
    ${props => props.available && !props.selected && `
      background: #c3dafe;
      border-color: #667eea;
    `}
  }
`;

export const PaymentSection = styled.div`
  background: #f7fafc;
  border-radius: 12px;
  padding: 20px;
  margin-top: 20px;
  
  h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0 0 16px 0;
  }
`;

export const PaymentOption = styled.button`
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 2px solid ${props => props.selected ? "#667eea" : "#edf2f7"};
  background: ${props => props.selected ? "#eef2ff" : "white"};
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  margin-bottom: 10px;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #667eea;
  }
  
  .icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: ${props => props.iconBg || "#667eea"};
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.1rem;
  }
  
  .info {
    text-align: left;
    flex: 1;
    
    h4 {
      font-size: 0.9rem;
      font-weight: 600;
      color: #2d3748;
      margin: 0 0 2px 0;
    }
    
    p {
      font-size: 0.75rem;
      color: #718096;
      margin: 0;
    }
  }
`;

export const ConfirmButton = styled.button`
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #48bb78, #38a169);
  color: white;
  border: none;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: 16px;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(72, 187, 120, 0.4);
  }
  
  &:disabled {
    background: #cbd5e0;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #a0aec0;
  
  i {
    font-size: 3rem;
    margin-bottom: 16px;
    opacity: 0.5;
  }
  
  h3 {
    font-size: 1.25rem;
    color: #4a5568;
    margin: 0 0 8px 0;
  }
  
  p {
    margin: 0;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  
  &::before {
    content: '';
    width: 4px;
    height: 20px;
    background: #667eea;
    margin-right: 10px;
    border-radius: 2px;
  }
`;
